namespace TabAurous.Stock {
    export namespace JobWorkMetalService {
        export const baseUrl = 'Stock/JobWorkMetal';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/JobWorkMetal/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobWorkMetalService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
